/**
 * Map View Button
 * @author Rhys Lloyd
 */


//
// Utilities
import debug from "debug";
const MODULE_NAME = 'map-view-button';
const log = debug(MODULE_NAME);

//
// Dependencies
import {
	MAP_VIEW_BUTTON_SELECTOR,
	MAP_VIEW_BUTTON_ACTION_DATA_ATTRIBUTE,
	LIST_VIEW_BUTTON_SELECTOR,
	LIST_VIEW_BUTTON_ACTION_DATA_ATTRIBUTE,
} from './config';

//
// Private Functions

/**
 * Initialises the Geolocation Button
 * @param button
 */
function initialiseMapViewButton (button) {
	log('initialiseMapViewButton:', button);

	const $button = $(button);
	const $form = $(button.form);

	$button.on('click.map-view-button', (event) => {
		event.preventDefault();
		$form.data('mode', 'map');
		const mapViewAction = $button.data(MAP_VIEW_BUTTON_ACTION_DATA_ATTRIBUTE);
		log('click.map-view-button', mapViewAction);
		$form.attr('action', mapViewAction).submit();
	});
}

/**
 * Initialises the List Result Button
 * @param button
 */
function initialiseListViewButton (button) {
	log('initialiseListViewButton:', button);

	const $button = $(button);
	const $form = $(button.form);

	$button.on('click.list-view-button', (event) => {
		event.preventDefault();
		event.stopImmediatePropagation();
		$form.data('mode', 'list');
		const listViewAction = $button.data(LIST_VIEW_BUTTON_ACTION_DATA_ATTRIBUTE);
		log('click.list-view-button', listViewAction);
		$form.attr('action', listViewAction).submit();
	});
}

//
// Export
export function exec () {
	log('Running...');
	const $map_buttons = $(MAP_VIEW_BUTTON_SELECTOR);
	if ($map_buttons.length) {
		$map_buttons.each((index, button) => {
			initialiseMapViewButton(button);
		});
	}

	const $list_buttons = $(LIST_VIEW_BUTTON_SELECTOR);
	if ($list_buttons.length) {
		$list_buttons.each((index, button) => {
			initialiseListViewButton(button);
		});
	}
}

export {exec as default};




// WEBPACK FOOTER //
// ./project/client/src/core/modules/navigation/map-view-button.js